/*
Controller: QuarterlyRoyaltiesStatements

Operations:
  createQuarterlyRoyaltiesStatements
  getQuarterlyRoyaltiesStatements
  downloadQuarterlyRoyaltiesStatement
*/
var Api = require('../config')
var QuarterlyRoyaltiesStatementsRequestDef = require('../definitions/QuarterlyRoyaltiesStatementsRequest')
var QuarterlyRoyaltiesStatementDownloadRequestDef = require('../definitions/QuarterlyRoyaltiesStatementDownloadRequest')

var QuarterlyRoyaltiesStatements = (function () {
  /*
  Operation: createQuarterlyRoyaltiesStatements
  Create quarterly royalties statements
  Parameters:
    bodyRequest: Quarterly royalties statements confirm request
  Responses:
    HTTP 200: Valid response
    HTTP 400: Input error
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Quarterly reports project not found
  */
  function createQuarterlyRoyaltiesStatementsQuarterlyRoyaltiesStatements (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        QuarterlyRoyaltiesStatementsRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/quarterlyRoyaltiesStatements'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getQuarterlyRoyaltiesStatements
  Get quarterly royalty earnings statements for a foundry and year
  Parameters:
    foundryId: MongoDB foundry id
    year: Year to fetch quarterly statements for
  Responses:
    HTTP 200: Quarterly royalty statements metadata
    HTTP 400: Invalid request
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Not Found
  */
  function getQuarterlyRoyaltiesStatementsQuarterlyRoyaltiesStatements (foundryId, year) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
        if (!year) {
          throw new Error('year: Missing parameter')
        }
        if (year && !(typeof year === 'string')) {
          throw new Error('year: Wrong type: Got "' + (typeof year) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['year'] = year
      var path = '/quarterlyRoyaltiesStatements/{foundryId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: downloadQuarterlyRoyaltiesStatement
  Get presigned URL to download a quarterly royalty earnings statement
  Parameters:

  Responses:
    HTTP 200: Presigned URL for the report PDF
    HTTP 400: Invalid request
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Report not found
  */
  function downloadQuarterlyRoyaltiesStatementQuarterlyRoyaltiesStatements (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        QuarterlyRoyaltiesStatementDownloadRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/quarterlyRoyaltiesStatements/download'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createQuarterlyRoyaltiesStatements'] = createQuarterlyRoyaltiesStatementsQuarterlyRoyaltiesStatements
  ret['getQuarterlyRoyaltiesStatements'] = getQuarterlyRoyaltiesStatementsQuarterlyRoyaltiesStatements
  ret['downloadQuarterlyRoyaltiesStatement'] = downloadQuarterlyRoyaltiesStatementQuarterlyRoyaltiesStatements
  return ret
})()

module.exports = QuarterlyRoyaltiesStatements
